import {
    CREATE_FEEDBACK_MASTER_REQUEST,
    CREATE_FEEDBACK_MASTER_SUCCESS,
    CREATE_FEEDBACK_MASTER_FAILURE,
    DELETE_FEEDBACK_MASTER_REQUEST,
    DELETE_FEEDBACK_MASTER_SUCCESS,
    DELETE_FEEDBACK_MASTER_FAILURE,
    FETCH_SINGLE_FEEDBACK_MASTER_REQUEST,
    FETCH_SINGLE_FEEDBACK_MASTER_SUCCESS,
    FETCH_SINGLE_FEEDBACK_MASTER_FAILURE,
    FETCH_FEEDBACK_MASTER_REQUEST,
    FETCH_FEEDBACK_MASTER_SUCCESS,
    FETCH_FEEDBACK_MASTER_FAILURE,
    UPDATE_FEEDBACK_MASTER_REQUEST,
    UPDATE_FEEDBACK_MASTER_SUCCESS,
    UPDATE_FEEDBACK_MASTER_FAILURE,
    RESET_FEEDBACK_MASTER_INFO,
    CREATE_FEEDBACK_MASTER_FORM,
    UPDATE_FEEDBACK_MASTER_FORM,
    NAVIGATE_FEEDBACK_MASTER,
    NAVIGATE_FEEDBACK_DETAILS
} from './feedbackMaster.actionsType';

export const FEEDBACK_MASTER = 'feedbackMaster';

let initialState = {
    loading: false,
    feedbackMaster: [],
    feedbackMasterform: {},
    selectedState: {},
    errorMessage: '',
    singleFeedback: {},
    isPartyDetails: false
};

export let feedbacktMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FEEDBACK_MASTER_REQUEST:
        case CREATE_FEEDBACK_MASTER_REQUEST:
        case UPDATE_FEEDBACK_MASTER_REQUEST:
        case FETCH_SINGLE_FEEDBACK_MASTER_REQUEST:
        case DELETE_FEEDBACK_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FEEDBACK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackMaster: updatePayload
            };
        case CREATE_FEEDBACK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackMasterform: {}
            };
        case UPDATE_FEEDBACK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackMasterform: {}
            };
        case FETCH_SINGLE_FEEDBACK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackMasterform: updatePayload
            };
        case DELETE_FEEDBACK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackMasterform: {}
            };
        case RESET_FEEDBACK_MASTER_INFO:
            return {
                ...state,
                feedbackMasterform: {}
            };
        case CREATE_FEEDBACK_MASTER_FORM:
        case UPDATE_FEEDBACK_MASTER_FORM:
            return {
                ...state,
                loading: false,
                feedbackMasterform: {
                    ...state.feedbackMasterform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FEEDBACK_MASTER_FAILURE:
        case CREATE_FEEDBACK_MASTER_FAILURE:
        case UPDATE_FEEDBACK_MASTER_FAILURE:
        case FETCH_SINGLE_FEEDBACK_MASTER_FAILURE:
        case DELETE_FEEDBACK_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_FEEDBACK_DETAILS:
            return {
                ...state,
                isPartyDetails: true,
                singleFeedback: payload.singleFeedback
            };
        case NAVIGATE_FEEDBACK_MASTER:
            return {
                ...state,
                isPartyDetails: false
            };
        default:
            return state;
    }
};
